import { Plus, Copy, Download, Save, Undo2 } from 'lucide-react';

interface BankBalanceToolbarProps {
    canEdit: boolean;
    hasChanges: boolean;
    saving: boolean;
    onNewEntry: () => void;
    onCopyFromDate: () => void;
    onExport: () => void;
    onSaveAll: () => void;
    onUndoAll: () => void;
}

export function BankBalanceToolbar({
    canEdit, hasChanges, saving,
    onNewEntry, onCopyFromDate, onExport, onSaveAll, onUndoAll,
}: BankBalanceToolbarProps) {
    return (
        <div className="flex items-center gap-2 flex-wrap">
            {canEdit && (
                <>
                    <button
                        onClick={onNewEntry}
                        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        <Plus className="w-4 h-4" />
                        New Entry
                    </button>
                    <button
                        onClick={onCopyFromDate}
                        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                        <Copy className="w-4 h-4" />
                        Copy from Date
                    </button>
                </>
            )}

            <button
                onClick={onExport}
                className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
                <Download className="w-4 h-4" />
                Export
            </button>

            {canEdit && hasChanges && (
                <>
                    <div className="w-px h-6 bg-gray-300 mx-1" />
                    <button
                        onClick={onSaveAll}
                        disabled={saving}
                        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:opacity-50 transition-colors"
                    >
                        <Save className="w-4 h-4" />
                        {saving ? 'Saving...' : 'Save All'}
                    </button>
                    <button
                        onClick={onUndoAll}
                        disabled={saving}
                        className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 transition-colors"
                    >
                        <Undo2 className="w-4 h-4" />
                        Undo
                    </button>
                </>
            )}
        </div>
    );
}
